import { __extends } from "tslib";
import { exposeGetters } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';
var AddonsThemeDark = /** @class */ (function (_super) {
    __extends(AddonsThemeDark, _super);
    function AddonsThemeDark() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AddonsThemeDark, "addonsTopBarIconColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsThemeDark, "addonsTopBarMenuItemHoverBg", {
        get: function () {
            return this.bgActive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsThemeDark, "addonsTopBarMenuItemHoverColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsThemeDark, "addonsTopBarMenuItemCommentColorHover", {
        get: function () {
            return this.textColorDisabledContrast;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsThemeDark, "addonsLogoColor", {
        //#endregion
        //#region Logotype
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsThemeDark, "addonsLogoButtonActionColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsThemeDark, "addonsUserAvatarColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsThemeDark, "addonsUserAvatarHoverColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsThemeDark, "addonsUserAvatarActiveColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsThemeDark, "addonsUserAvatarBorderColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    //#region TopBar
    AddonsThemeDark.addonsTopBarDividerBg = 'rgba(255, 255, 255, 0.08)';
    AddonsThemeDark.addonsTopBarItemActionBackground = '#313131';
    AddonsThemeDark.addonsTopBarMenuSeparatorColor = 'rgba(255, 255, 255, 0.08)';
    AddonsThemeDark.addonsLogoButtonActionBackground = '#1F1F1F';
    //#endregion
    //#region UserAvatar
    AddonsThemeDark.addonsUserAvatarBackground = 'transparent';
    AddonsThemeDark.addonsUserAvatarHoverBackground = '#1F1F1F';
    AddonsThemeDark.addonsUserAvatarActiveBackground = '#1F1F1F';
    return AddonsThemeDark;
}(/** @class */ (function () {
    function class_1() {
    }
    return class_1;
}())));
export { AddonsThemeDark };
export var AddonsThemeDarkInternal = exposeGetters(AddonsThemeDark);
